import { render } from "./ui-scrollbar.vue?vue&type=template&id=36f2ae18"
import script from "./ui-scrollbar.vue?vue&type=script&lang=js"
export * from "./ui-scrollbar.vue?vue&type=script&lang=js"

import "./ui-scrollbar.vue?vue&type=style&index=0&id=36f2ae18&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__